import { defineAbility } from '@casl/ability';
import store from './store';
import { UserRole } from '@gpx-spa/constants';
import { getCookie } from '@/utils/cookie';

export default () => defineAbility((can) => {
    const user = store.getters['auth/user'];
    if (!user) return;

    const account = store.getters['auth/account'];
    if (!account) return;

    const accountSettingIsOn = store.getters['auth/accountSettingIsOn'];
    const role = user.account_roles[account.id];

    // AI chat access is available to all roles if the account setting is enabled
    accountSettingIsOn('ai_available') && can('use', 'Ai');
    
    // Insights access is available to all roles if the account setting is enabled
    accountSettingIsOn('proactive_ai_reports_available') && can('use', 'Insights');

    // Viewers read shipments but never write them, so visibility is `view` and every
    // write stays behind the `manage` grant below. The nav re-checks the account flag
    // because CASL treats `manage` as a wildcard action: a non-Viewer's `manage` grant
    // answers `view` too, on an account that cannot track shipments at all.
    account.can_track_shipments && can('view', 'Shipments');

    // Container types are shown on every tracker, so any role may read the vocabulary;
    // managing it is the account admin's, matching the engine's policy.
    const hasReturnableContainers = accountSettingIsOn(
      'returnable_containers_available',
    );
    hasReturnableContainers && can('view', 'ContainerTypes');

    if (role === UserRole.Admin) {
      can('manage', 'Geofences');
      accountSettingIsOn('ble_tags') && can('view', 'Anchors');
      can('manage', 'Account');
      can('manage', 'Groups');
      // Both API credentials are account-wide, so both sit at the admin bar — the legacy key
      // included, which was visible to every role until ENG-2867. Each still needs its own
      // entitlement: the new one a setting, the legacy one a column.
      accountSettingIsOn('public_api_v1_available') &&
        can('manage', 'ApiTokens');
      hasReturnableContainers && can('manage', 'ContainerTypes');
      account.has_api_access && can('view', 'LegacyApiKey');
    }
    if (role === UserRole.Admin || role === UserRole.Manager) {
      accountSettingIsOn('dashboards') && can('view', 'Dashboard');
      accountSettingIsOn('ble_tags') && can('view', 'Anchors');
      can('manage', 'Users');
      can('manage', 'Reports');
      can('manage', 'Geofences');
    }
    if (role !== UserRole.Viewer) {
      can('manage', 'Shipments');
      can('manage', 'Devices');
      can('manage', 'Rules');
      accountSettingIsOn('ble_tags') && can('manage', 'Anchors');
    }

    const isGpxAdmin = store.getters['auth/isGpxAdmin'];
    const isImitating = getCookie('imitation_token');

    if (isGpxAdmin || isImitating) {
      can('manage', 'AiModel');
      can('manage', 'MapOverlay');
    }
});
